import React from 'react';
import icon1 from './icon-1.svg'
import icon2 from './icon-2.svg'
import icon3 from './icon-3.svg'
import icon4 from './icon-4.svg'
import './social-list.scss';


function SocialList() {
    return (
        <div className="social-list">
            <div className="social-list__icon">
                <img src={icon1} alt="TikTok" />
            </div>
            <div className="social-list__icon">
                <img src={icon2} alt="Telegram" />
            </div>
            <div className="social-list__icon">
                <img src={icon3} alt="Twitter" />
            </div>
            <div className="social-list__icon">
                <img src={icon4} alt="instagram" />
            </div>
        </div>
    );
}

export default SocialList;